import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import MySideBar from '../common/MySideBar';
import ListPhases from './ListPhases';

//Create Phase dependencies
import MyTooltip from '../common/MyTooltip';
import CreatePhaseModel from './CreatePhaseModel';

import {
  CREATE_PROJECT_MODEL_ACTION_CREATE, 
  CREATE_PROJECT_MODEL_ACTION_EDIT,
  CREATE_PROJECT_MODEL_ACTION_SHOW,
  ROLE_ADMIN
} from '../common/redux/constantes';


export class DefaultPage extends Component {

  state = {
    openCreatePhaseDialog:false,
    createPhaseDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
    phaseEdit:{}
  }


  static propTypes = 
  {
    phase: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };


  closeCreatePhaseDialog = ()=>
  {
    this.setState({openCreatePhaseDialog:false});
    this.list.wrappedInstance.refreshTable();
  }

  openCreatePhaseDialog = ()=>{
    this.setState({
      openCreatePhaseDialog:true, 
      createPhaseDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
      phaseEdit:{}
    });
  }

  editPhase = (phase)=>{
     this.setState({
      openCreatePhaseDialog:true, 
      createPhaseDialogAction:CREATE_PROJECT_MODEL_ACTION_EDIT,
      phaseEdit:phase
    });
  }

  showPhase = (phase)=>{
     this.setState({
      openCreatePhaseDialog:true, 
      createPhaseDialogAction:CREATE_PROJECT_MODEL_ACTION_SHOW,
      phaseEdit:phase
    });
  }

  render() {
    return (
      <div >
          <MySideBar>
            <ListPhases ref={instance => { this.list = instance; }} editPhase={this.editPhase} showPhase={this.showPhase}/>
            <CreatePhaseModel 
              openDialog={this.state.openCreatePhaseDialog} 
              closeDialog={this.closeCreatePhaseDialog} 
              actionDialog={this.state.createPhaseDialogAction}
              phaseEdit={this.state.phaseEdit}
            />
            {
              Number(localStorage.getItem("role")) === ROLE_ADMIN?
              (<MyTooltip openDialog={this.openCreatePhaseDialog} />)
              :null
            }
        </MySideBar>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    phase: state.phase,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/phase/DefaultPage.js